<template>
  <div>
    <header>
      <div class="mx-auto pt-4 px-16">
        <h3 class="text-lg leading-6 font-medium">
          Agent Portal Homepage
        </h3>
      </div>
    </header>
    <div class="relative flex flex-col w-full">
      <div class="flex-grow w-full mx-auto xl:px-8 lg:flex">
        <div class="flex-1 min-w-0 bg-gray-50 xl:flex">
          <div class="lg:min-w-0 lg:flex-1">
            <div class="h-full py-6 px-4 sm:px-6 lg:px-8">
              <div
                class="bg-white relative px-4 py-5 inset-0 border-2 border-gray-200 border-dashed rounded-lg flex flex-col"
                style="min-height: 36rem">
                <div role="list" class="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-5">
                  <div
                    class="col-span-1 flex items-baseline flex-wrap justify-between gap-y-2 gap-x-4 border-t border-gray-900/5 px-4 py-4 sm:px-6 lg:border-t-0 xl:px-8 sm:border-l bg-gray-100">
                    <dt class="text-sm font-medium leading-6 text-gray-500"># of Companies</dt>
                    <!-- <dd class="text-xs font-medium text-rose-600">+54.02%</dd> -->
                    <dd class="w-full flex-none text-3xl font-medium leading-10 tracking-tight text-gray-900"> {{
                      agent_user?.number_of_companies }}
                    </dd>
                  </div>
                  <div
                    class="col-span-1 flex items-baseline flex-wrap justify-between gap-y-2 gap-x-4 border-t border-gray-900/5 px-4 py-4 sm:px-6 lg:border-t-0 xl:px-8 sm:border-l bg-gray-100">
                    <dt class="text-sm font-medium leading-6 text-gray-500"># of Members</dt>
                    <!-- <dd class="text-xs font-medium text-rose-600">+54.02%</dd> -->
                    <dd class="w-full flex-none text-3xl font-medium leading-10 tracking-tight text-gray-900"> {{
                      agent_user?.number_of_members }}
                    </dd>
                  </div>
                </div>
                <!-- </div> -->
                <b class="text-xl pt-5"
                  v-if="agent_user?.agent_access != null && (agent_user?.agent_access[0] == true || agent_user?.agent_access[1] == true || agent_user?.agent_access[2] == true)">Reports:</b>
                <div class="flex  px-6 flex-1 w-full"
                  v-if="agent_user?.agent_access != null && (agent_user?.agent_access[0] == true || agent_user?.agent_access[1] == true || agent_user?.agent_access[2] == true)">
                  <div class="space-y-0 flex justify-between w-full flex-wrap items-center">
                    <div class="relative" v-if="agent_user?.agent_access && agent_user?.agent_access[0] == true">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                        class="absolute -top-0.5 z-10 -ml-3.5 h-7 w-7 rounded-full cobalt-text-color">
                        <path fill-rule="evenodd"
                          d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                          clip-rule="evenodd" />
                      </svg>
                      <div class="ml-6">
                        <h4 class="font-bold cobalt-text-color cursor-pointer w-max"
                          @click="RedirectTopage('/commission_report')">Commission
                          Report</h4>
                        <p class="mt-2 max-w-screen-sm text-sm text-gray-500">This new report is available for January
                          2024 commission report and moving forward.</p>
                      </div>
                    </div>
                    <div class="relative" v-if="agent_user?.agent_access && agent_user?.agent_access[1] == true">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                        class="absolute -top-0.5 z-10 -ml-3.5 h-7 w-7 rounded-full cobalt-text-color">
                        <path fill-rule="evenodd"
                          d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                          clip-rule="evenodd" />
                      </svg>
                      <div class="ml-6">
                        <h4 class="font-bold cobalt-text-color cursor-pointer w-max"
                          @click="RedirectTopage('/membership_report')">Membership
                          Report</h4>
                        <p class="mt-2 max-w-screen-sm text-sm text-gray-500"> This report is where you can view your
                          active, inactive, and terminated members.</p>
                      </div>
                    </div>
                    <div class="relative" v-if="agent_user?.agent_access && agent_user?.agent_access[2] == true">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                        class="absolute -top-0.5 z-10 -ml-3.5 h-7 w-7 rounded-full cobalt-text-color">
                        <path fill-rule="evenodd"
                          d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                          clip-rule="evenodd" />
                      </svg>
                      <div class="ml-6">
                        <h4 class="font-bold cobalt-text-color cursor-pointer w-max"
                          @click="RedirectTopage('/company_statistics_report')">Company
                          Statistics</h4>
                        <p class="mt-2 max-w-screen-sm text-sm text-gray-500">This report is where you can view your
                          companies by month/year, along with data including # of eligible employees, # of active
                          policyholders, and the account penetration percentage (# of active policyholders divided by #
                          of eligible employees).</p>
                      </div>
                    </div>
                  </div>
                </div>
                <b class="text-xl"
                  v-if="agent_user?.is_agent == 'Yes' && agent_user?.agent_access != null && (agent_user?.agent_access[3] == true || agent_user?.agent_access[4] == true || agent_user?.agent_access[5] == true || agent_user?.agent_access[6] == true)">Quick
                  Links:</b>
                <div class="flex  px-6 py-4"
                  v-if="agent_user?.is_agent == 'Yes' && agent_user?.agent_access != null && (agent_user?.agent_access[3] == true || agent_user?.agent_access[4] == true || agent_user?.agent_access[5] == true || agent_user?.agent_access[6] == true)">
                  <div class="ml-6" v-if="agent_user?.agent_access && agent_user?.agent_access[3] == true">
                    <h4 class="font-bold cobalt-text-color cursor-pointer"
                      @click="RedirectTopage('', 'https://apps.uslegalservices.net/asso/Agent_Event.asp')">Supply Order
                      Form</h4>

                  </div>
                  <div class="ml-6" v-if="agent_user?.agent_access && agent_user?.agent_access[4] == true">
                    <h4 class="font-bold cobalt-text-color cursor-pointer"
                      @click="RedirectTopage('', 'https://apps.uslegalservices.net/CEF/')">Company Enrollment Form</h4>
                  </div>
                  <div class="ml-6" v-if="agent_user?.agent_access && agent_user?.agent_access[5] == true">
                    <h4 class="font-bold cobalt-text-color cursor-pointer"
                      @click="RedirectTopage('', 'https://apps.uslegalservices.net/services/App_test2/agent_2024.asp?A=' + agent_user?.associateNumber)">
                      Application Entry</h4>
                  </div>
                  <div class="ml-6" v-if="agent_user?.agent_access && agent_user?.agent_access[6]==true">
                    <h4 class="font-bold cobalt-text-color cursor-pointer" @click="generateQTURL()">Quoting Tool</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import Constants from "../constants.ts";

export default {
  computed: mapState(["agent_user"]), // get central level variable from store,
  data() {
    return {
      application_entry: "",
      BASE_EXT: Constants.BASE_EXT,
    }
  },
  methods: {
    generateQTURL() {
      let url;
    if(this.agent_user?.agent_access[7]==true){
      url=this.BASE_EXT+"usl-customer-portal/quote_tool/#!/dashboard?u="+this.agent_user.associateNumber+"&ac=ac&c=A&AGENTID="+this.agent_user.id
          window.open(url, '_blank');
    }else if(this.agent_user?.agent_access[8]==true){
      url=this.BASE_EXT+"usl-customer-portal/quote_tool/#!/dashboard?u="+this.agent_user.associateNumber+"&ac=ex&c=A&AGENTID="+this.agent_user.id    
    }else{
      url=this.BASE_EXT+"usl-customer-portal/quote_tool_usl/#!/dashboard?u="+this.agent_user.associateNumber+"&c=A&AGENTID="+this.agent_user.id
    }
    window.open(url, '_blank');
    },
    RedirectTopage(page = '', path = '') {
      if (path != '') {
        window.open(path, '_blank');
      } else {
        this.$router.push(page);
      }
    }
  },
};
</script>